import { IReleaseNote } from "../types"

export const RELEASE_1_4_10: IReleaseNote = {
    status: "PAST",
    title: "v1.4.10",
    date: "4th December 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "This Patch includes a bug fix relating to the 'property supply voltage' that meant any value was accepted. Additional validation has been added to prevent this",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "The following changes have been addedd:",
            bullets: [
                "We have updated the Connection Applicatoins API to enforce strict validation to the field 'declaredVoltageAtConnectionPoint' to ensure only the values of either '200 V' or '430 V' can be entered",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
